<div
    (mouseleave)="onMouseLeaveSidebar()"
    (mouseenter)="onMouseEnterSidebar()"
    id="kt_app_sidebar"
    [class.sidebar-active]="isExpanded"
    class="app-sidebar flex-column"
>
    @if (isExpanded) {
        <div (click)="hideSidebar()" class="app-sidebar-overlay"></div>
    }

    <!--begin::sidebar menu-->
    <div
        [@expand]="isExpanded ? expandAnimEnd : expandAnimStart"
        (@expand.start)="animationEventHandler($event)"
        (@expand.done)="animationEventHandler($event)"
        [class.sidebar-active]="isExpanded"
        class="app-sidebar-menu flex-column-fluid"
    >
        <!--begin::Logo-->
        <div class="upper-part-sidebar">
            <div class="sidebar-logo" id="kt_app_sidebar_logo">
                @if (logoUrl && smallLogoUrl) {
                    <a routerLink="/" class="logo-wrapper" (click)="onLogoClick()">
                        <img
                            alt="Logo"
                            [class.large]="isExpanded"
                            [class.small]="!isExpanded"
                            [src]="(isExpanded ? logoUrl : smallLogoUrl) | cdnImage"
                        />
                    </a>
                }
            </div>
            <div class="fix-navbar-button">
                <app-svg-icon icon="check-square" (click)="toggleSidebarDock()" />
            </div>
        </div>
        <!--end::Logo image-->
        <!--begin::Menu wrapper-->
        <div
            id="kt_app_sidebar_menu_wrapper"
            class="app-sidebar-wrapper my-5"
            data-kt-scroll="true"
            data-kt-scroll-activate="true"
            data-kt-scroll-dependencies="#kt_app_sidebar_logo, #kt_app_sidebar_footer"
            data-kt-scroll-wrappers="#kt_app_sidebar_menu"
            data-kt-scroll-offset="5px"
            data-kt-scroll-save-state="true"
        >
            <side-bar-menu [openAccordions]="openAccordions"></side-bar-menu>
        </div>
        <!--end::Menu wrapper-->
    </div>
    <!--end::sidebar menu-->
</div>
